/**
 * Description: 常见 ContentType 类型
 * @author: lhc
 * @date: 2022/2/7 18:13
 */
class CommonContentType {

  static _CONTENT_TYPE_KEY = 'Content-Type'


  static _TEXT = {
    HTML: 'text/html',//HTML格式
    PLAIN: 'text/plain',//纯文本格式
    XML: 'text/xml'//XML格式
  }

  static _IMAGE = {
    GIF: 'image/gif',//gif图片格式
    JPEG: 'image/jpeg',//jpg图片格式
    PNG: 'image/png',//png图片格式
  }

  static _APPLICATION = {
    XHTML_XML: 'application/xhtml+xml',//XHTML格式
    XML: 'application/xml',//XML数据格式
    ATOM_XML: 'application/atom+xml',//Atom XML聚合格式
    JSON: 'application/json',//JSON数据格式
    PDF: 'application/pdf',//pdf格式
    MSWORD: 'application/msword',//Word文档格式
    OCTET_STREAM: 'application/octet-stream',//二进制流数据（如常见的文件下载）
    X_WWW_FORM_URLENCODED: 'application/x-www-form-urlencoded',// <form encType=””>中默认的encType，form表单数据被编码为key/value格式发送到服务器（表单默认的提交数据的格式）
  }

  static _MULTIPART = {
    FORM_DATA: 'multipart/form-data'//需要在表单中进行文件上传时，就需要使用该格式
  }

}

export default CommonContentType
